// extracted by mini-css-extract-plugin
export default {"title":"PageTitle-module__title--v3stc","subtitle":"PageTitle-module__subtitle--Goabc","animatedBackground":"PageTitle-module__animatedBackground--zzoCP"};